import type { AuthFailureCode } from './auth-client.ts';

export type PasskeyMergeFailure = {
  actionError: AuthFailureCode | null;
  mergeError: 'merge-conflict' | null;
};

export function classifyAuthFailure(error: unknown): AuthFailureCode {
  return error instanceof Error
    ? (error.message as AuthFailureCode)
    : 'authentication';
}

/** Keep merge conflicts in the merge surface instead of the global auth error. */
export function classifyPasskeyMergeFailure(
  error: unknown,
): PasskeyMergeFailure {
  const code = classifyAuthFailure(error);
  return code === 'merge-conflict'
    ? { actionError: null, mergeError: code }
    : { actionError: code, mergeError: null };
}
